import axios from "axios";
// import { Toast } from "vant";
import _ from "lodash";
import config from "@/config";
import Cookies from 'js-cookie'

const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : process.env.NODE_ENV === "daily"
    ? config.baseUrl.daily
    : config.baseUrl.pro;

// console.log(process.env.NODE_ENV, baseUrl);
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;

const getReqData = (data, type) => {
  return transformRequest(data, type);
};

const transformRequest = (data, type) => {
  if (type === "post") {
    //data = JSON.stringify(data);
    return data;
  } else {
    let str = "";
    _.forIn(data, (value, key) => {
      if (key) {
        if (typeof value === "string" || typeof value === "number") {
          str += `${str.length ? "&" : ""}${key}=${value}`;
        } else {
          str += `${str.length ? "&" : ""}${key}=${JSON.stringify(value)}`;
        }
      }
    });
    return str;
  }
};

const processRes = res => {
  if ((res.status = 200 && res.data)) {
    if (res.data.code === 0) {
      if (typeof res.data.data == "object") {
        return {
          ...res.data.data,
          apiStatus: true
        };
      } else {
        return {
          data: res.data.data,
          apiStatus: true
        };
      }
    } else if (res.data.code == "20011") {
      // this.$Message.warning(res.data.msg);
      Cookies.remove('user_id')
      const diffPage = window.location.origin.split('//')[1].indexOf('jiuyeyuren') > -1 || window.location.origin.split('//')[1].indexOf('biyeshen') > -1 || window.location.origin.split('//')[1].indexOf('applyoffer') > -1
      if(diffPage) {
        window.location.href = window.location.origin
      }else {
        window.location.href = "/#/login";
      }
      return {
        apiStatus: false,
        data: res.data
      };
    } else if (res.data.code == "20013") {
      // console.log('没有简历')
      // window.location.href = "/#/resume/detail";
      return {
        apiStatus: false,
        data: res.data
      };
    }else if (res.data.code == "30001") {
      // console.log('没有简历')
      // window.location.href = "/#/resume/detail";
      return {
        apiStatus: false,
        data: res.data
      };
    } else {
      return {
        apiStatus: false,
        data: res.data
      };
    }
  } else {
    return {
      apiStatus: false,
      code: res.code,
      statusText: res.statusText
    };
  }
};

const request = {
  async get(url, data, key, ismock) {
    data = data || {};
    data.public_source = 1;
    const reqData = getReqData(data, "get");
    const res = await axios.get(`${baseUrl}${url}?${reqData}`);
    return processRes(res);
  },
  async post(url, data, key, ismock, needTransform = true) {
    data = data || {};
    data.public_source = 1;
    let options = {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      data: data,
      url: `${baseUrl}${url}`,
      ...key
    };
    if (needTransform) {
      options.transformRequest = [
        function(data) {
          let ret = "";
          for (let it in data) {
            let value =
              typeof data[it] === "object"
                ? JSON.stringify(data[it])
                : data[it];
            ret +=
              encodeURIComponent(it) + "=" + encodeURIComponent(value) + "&";
          }
          return ret;
        }
      ];
    }
    const res = await axios(options);
    return await processRes(res);
  }
};

export default request;



// WEBPACK FOOTER //
// ./src/api/http.js